export const productsSectionTexts = {
  title: 'Nuestras',
  titleHighlight: 'Categorías',
  subtitle: 'Solicita el catálogo completo con precios mayoristas',
  buttonText: 'Solicitar Lista de Precios',
  buttonIcon: 'ri-download-line',
  categoryButtonText: 'Ver Más',
  bottomButtonText: 'Pide el Catálogo por WhatsApp',
  bottomButtonIcon: 'ri-whatsapp-line'
};
